import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    authSync: null // 跨应用登录状态同步实例
  },
  mutations: {
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_AUTH_SYNC(state, authSync) {
      state.authSync = authSync
    }
  },
  actions: {
    setLoading({ commit }, loading) {
      commit('SET_LOADING', loading)
    }
  },
  modules: {
    auth
  }
})



